import { takeLatest, put, call } from 'redux-saga/effects';
import { getSamlLoginUrl, setTokenCookie } from '../../auth/session';
import * as authenticationService from '../../services/authentication/authenticationService';
import {
  refreshTokenFailed,
  refreshTokenSuccess,
  REFRESH_TOKEN_START,
  REFRESH_TOKEN_START_ACTION
} from '../actions/authentication/refreshTokenActions';

function* refreshToken(action: REFRESH_TOKEN_START_ACTION) {
  const { pathname, search } = action.payload;
  try {
    const response: { token: string } = yield call(
      authenticationService.refreshToken
    );

    setTokenCookie(response?.token);
    yield put(refreshTokenSuccess());
  } catch (e: unknown) {
    yield put(refreshTokenFailed((e as { message: string })?.message));
    window.location = getSamlLoginUrl(pathname, search) as any;
  }
}

export default function* authenticationSaga() {
  yield takeLatest(REFRESH_TOKEN_START, refreshToken);
}
